import React, { useState, useEffect, useMemo } from 'react';
import api from '../../services/api';
import { useForm } from "react-hook-form";
import { yupResolver } from "@hookform/resolvers/yup";
import * as yup from "yup";
import { DateBox } from "devextreme-react/date-box";
import "bootstrap/dist/css/bootstrap.min.css";
import { useNavigate, useLocation } from "react-router-dom";
import DataGrid, { Column, Paging, Pager } from 'devextreme-react/data-grid';
import { LoadPanel } from 'devextreme-react/load-panel';

const schema = yup.object().shape({
  status: yup.string().required("Required"),
  statusDate: yup.date().required("Required"),
});

const ChangeApplicantStatus = () => {
  const location = useLocation();
  const selectedIds = location.state?.selectedIds;

  const [isLoading, setIsLoading] = useState(false);
  const [applicants, setApplicants] = useState([]);
  const [errorMessage, setErrorMessage] = useState(""); // ✅ NEW

  const navigate = useNavigate();

  const {
    register,
    handleSubmit,
    setValue,
    watch,
    formState: { errors },
  } = useForm({
    resolver: yupResolver(schema),
  });

  // Fetch applicants
  useEffect(() => {
    if (!selectedIds || selectedIds.length === 0) return;

    setIsLoading(true);

    api.post('/Applicants/selectedlist', selectedIds)
      .then((res) => {
        const data = res.data.map((item) => ({
          ...item,
          ID: item.id,
        }));
        setApplicants(data);
      })
      .catch(() => {
        setErrorMessage("Failed to load applicants.");
      })
      .finally(() => setIsLoading(false));
  }, [selectedIds]);

  /*const formatDate = (date) => {
    if (!date) return "";
    const d = new Date(date);
    d.setHours(0, 0, 0, 0);
    return d.toISOString().split("T")[0];
  };*/

  const formatDate = (date) => {
    if (!date) return "";
    const d = new Date(date);
    const year = d.getFullYear();
    const month = String(d.getMonth() + 1).padStart(2, '0');
    const day = String(d.getDate()).padStart(2, '0');
    return `${year}-${month}-${day}`;
  };

  const handleFormSubmit = async (data) => {
    setErrorMessage(""); // ✅ clear old error

    const { status, statusDate } = data;

    if (!selectedIds || selectedIds.length === 0) {
      setErrorMessage("Please select at least one applicant.");
      return;
    }

    if (!status || !statusDate) {
      setErrorMessage("Please fill in all required fields.");
      return;
    }

    setIsLoading(true);

    try {
      alert(statusDate);
      const formattedDate = formatDate(statusDate);
      alert(formattedDate);

      await api.post(
        `/Applicants/changeStatus?status=${encodeURIComponent(status)}&statusDate=${formattedDate}`,
        selectedIds,
        {
          headers: { "Content-Type": "application/json" },
        }
      );

      navigate("/applicants/applicantlist");
    } catch (error) {
      setErrorMessage(
        error.response?.data || "Failed to update applicant status."
      );
    } finally {
      setIsLoading(false);
    }
  };

  const columns = useMemo(() => [
    { field: 'passportNo', caption: 'Passport No.' },
    { field: 'fullName', caption: 'Full Name' },
    { field: 'agent', caption: 'Agent' },
  ], []);

  return (
    <div className="container mt-4" style={{ maxWidth: "1100px" }}>
      <h5 className="es-label-title">CHANGE STATUS</h5>

      <div className="card p-3">

        {/* ✅ ERROR ALERT */}
        {errorMessage && (
          <div className="alert alert-danger alert-dismissible fade show" role="alert">
            {errorMessage}
            <button
              type="button"
              className="btn-close"
              onClick={() => setErrorMessage("")}
            ></button>
          </div>
        )}

        <form onSubmit={handleSubmit(handleFormSubmit)}>

          <LoadPanel
            shadingColor="rgba(0,0,0,0.4)"
            position={{ of: '.dx-datagrid' }}
            visible={isLoading}
            showIndicator={true}
            shading={false}
            showPane={true}
          />

          <div className="row">

            {/* LEFT SIDE */}
            <div className="col-md-5">
              <div className="row">

                {/* STATUS */}
                <label className="col-sm-4 col-form-label">Status</label>
                <div className="col-sm-8 mb-2">
                  <select {...register("status")} className="form-control">
                    <option value=""></option>
                    <option value="REGISTERED">REGISTERED</option>
                    <option value="AVAILABLE">AVAILABLE</option>
                    <option value="CV-SENT">CV-SENT</option>
                    <option value="SELECTED">SELECTED</option>
                    <option value="ASHARA">ASHARA</option>
                    <option value="IN-EMBASSY">IN-EMBASSY</option>
                    <option value="VISA STAMPED">VISA STAMPED</option>
                    <option value="LMIS">LMIS</option>
                    <option value="TICKET BOOKED">TICKET BOOKED</option>
                    <option value="TRAVELED">TRAVELED</option>
                    <option value="COMPILING DOC">COMPILING DOC</option>
                    <option value="MOL-APPROVED">MOL-APPROVED</option>
                    <option value="MEDICAL RETURNEE">MEDICAL RETURNEE</option>
                    <option value="REFUSAL">REFUSAL</option>
                    <option value="RETURNED">RETURNED</option>
                    <option value="DEPORTED">DEPORTED</option>
                    <option value="RUNAWAY">RUNAWAY</option>
                    <option value="COMPLETED">COMPLETED</option>
                    <option value="EXTENDED">EXTENDED</option>
                    <option value="VISA CANCELED">VISA CANCELED</option>
                  </select>
                  {errors.status && <small className="text-danger">Required</small>}
                </div>

                {/* DATE */}
                <label className="col-sm-4 col-form-label">Status Date</label>
                <div className="col-sm-8 mb-3">
                  <DateBox
                        value={watch("statusDate")}
                        displayFormat="dd/MM/yyyy" // Ensures proper date format
                        placeholder="DD/MM/YYYY"  // Watermark
                        onValueChanged={(e) => setValue("statusDate", e.value)}
                        min={new Date("2000-01-01")}
                        width={"100%"}
                    />
                  {errors.statusDate && <small className="text-danger">Required</small>}
                </div>

                {/* BUTTON */}
                <div className="col-sm-12 text-end">
                  <button type="submit" className="btn btn-primary">
                    SAVE
                  </button>
                </div>

              </div>
            </div>

            {/* RIGHT SIDE GRID */}
            <div className="col-md-7">
              <DataGrid
                dataSource={applicants}
                showBorders
                rowAlternationEnabled
                columnAutoWidth
                keyExpr="ID"
                height={300}
              >
                <Paging defaultPageSize={15} />
                <Pager showPageSizeSelector allowedPageSizes={[10, 20, 50]} showInfo />

                {columns.map(({ field, caption }) => (
                  <Column key={field} dataField={field} caption={caption} />
                ))}
              </DataGrid>
            </div>

          </div>
        </form>
      </div>
    </div>
  );
};

export default ChangeApplicantStatus;